import { useRef, useEffect } from 'react';

import Uploader from '~/utils/uploader';

function useUploader() {
  const _dom = useRef(null);
  const _uploader = useRef(null);

  useEffect(() => {
    _uploader.current = new Uploader({
      id: _dom.current,
      url: `http://test-dabang-pro-v2.dabangapp.com/api/v2/user/info/profile`,
      clickElement: _dom.current,
      options: {
        maxFilesize: 10,
        // withCredentials: false,
        // acceptedFiles: '*',
        // dictInvalidFileType: 'JP(E)G, PNG 확장자 파일만 업로드 가능합니다.'
      },
    });

    return () => {
      _uploader.current.destroy();
    };
  }, []);

  useEffect(() => {
    _uploader.current.on({
      onAddedfile: file => {
        alert(`added\n${JSON.stringify(file)}`);
      },
      onSending(file, xhr, formData) {
        console.log('sending');
        // changeSending(true);
        // formData.append('category', 'SIGNATURES');
        // formData.append('type', 'SEAL');
      },
      onSuccess: (file, { result }) => {
        alert(JSON.stringify(file, result));
      },
      onError: (file, msg, xhr) => {
        alert(JSON.stringify(xhr));
      }
    });

    return () => {
      _uploader.current.off();
    };
  }, []);

  useEffect(() => {
    console.log(_uploader.current);
  }, [_uploader]);

  return {
    _dom,
  };
}

export default useUploader;
